import React, { useState } from "react";
import Slider from "react-slick";
import styled from "styled-components";
import tw from "twin.macro";
import { Link } from "react-router-dom";
import { SectionHeading, Subheading as SubheadingBase } from "../misc/Headings.js";
import { ReactComponent as QuotesLeftIcon } from "../../images/quotes-l.svg";
import { ReactComponent as QuotesRightIcon } from "../../images/quotes-r.svg";
import { ReactComponent as SvgDecoratorBlob1 } from "../../images/svg-decorator-blob-4.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "../../images/svg-decorator-blob-5.svg";
import SwiperCard from "../swiper/CoverflowSwiper.js";

import "slick-carousel/slick/slick.css";

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-6`;
const DestinationsContainer = tw.div`mt-8 mb-4`;
const Destinations = styled.div``;
const Destination = tw.div`max-w-md lg:max-w-none mx-auto lg:mx-0 flex flex-col lg:flex-row items-center lg:items-stretch`;

const DestinationImageSlider = tw(SwiperCard)`w-full lg:w-2/3 flex-shrink-0`;
const DestinationTextSlider = tw(Slider)``;
const DestinationText = tw.div`outline-none`;

const TextContainer = styled.div(props => [
  tw`flex flex-col w-full lg:w-1/3`,
  props.textOnLeft ? tw`lg:pr-12 lg:order-first` : tw`lg:pl-12 lg:order-last`,
]);

const Subheading = tw(SubheadingBase)`mb-4 text-2xl`;
const HeadingTitle = tw(SectionHeading)`text-left w-full text-xl lg:text-2xl`;
const Description = tw.p`max-w-md text-center mx-auto lg:mx-0 lg:text-left lg:max-w-none leading-relaxed text-sm sm:text-base lg:text-lg font-medium mt-4 text-secondary-100`;

const QuoteContainer = tw.div`relative mt-2 lg:mt-4`;
const Quote = tw.blockquote`text-center lg:text-left text-sm sm:text-base lg:text-lg xl:text-xl`;

const DecoratorBlob1 = tw(
  SvgDecoratorBlob1
)`absolute w-32 top-0 left-0 -z-10 text-[#0049AC] opacity-25 transform -translate-x-full`;
const DecoratorBlob2 = tw(
  SvgDecoratorBlob2
)`absolute w-32 bottom-0 right-0 -z-10 text-pink-500 opacity-15 transform translate-x-2/3 translate-y-8`;

const PrimaryAction = tw.button`rounded-full px-6 py-3 mt-5 text-sm sm:text-base sm:mt-16 sm:px-8 sm:py-4 bg-[#0049AC] font-bold shadow transition duration-300 text-gray-100 focus:outline-none focus:shadow-outline`;

const QuotesLeft = tw(QuotesLeftIcon)`w-6 h-6 opacity-75 text-[#0049AC] inline-block mr-1 -mt-3`;
const QuotesRight = tw(QuotesRightIcon)`w-6 h-6 opacity-75 text-[#0049AC] inline-block ml-1 -mt-3`;

export default ({
  subheading = "Experience the Best Destinations Around the Globe",
  heading = "Destinations",
  description = "Explore a wide range of breathtaking destinations, from serene beaches to vibrant cities, offering something for every type of traveler.",
  textOnLeft = false
}) => {
  const [activeSlide, setActiveSlide] = useState(null);


  const handleSlideChange = (data) => {
    setActiveSlide({
      id: data.id || "Destination Id",
      title: data.title || "Unknown Destination",
      city: data.city || "City not available",
      state: data.state || "State not available",
      country: data.country || "Country not available",
      description: data.description || "No description available.",
    });
  };

  return (
    <Container id="destinationSection">
      <br />
      <Content>
        <HeadingInfoMain
          tw="text-center lg:block"
          subheading={subheading}
          />
        <br />
        <PrimaryAction as={Link} to="/pg/destinations">All Destinations</PrimaryAction>
        <DestinationsContainer>
          <Destinations>
            <Destination>
              <br/>
              <DestinationImageSlider onSlideChange={handleSlideChange} />
              <br/>
              <TextContainer textOnLeft={textOnLeft}>
                <HeadingInfo
                  tw="hidden lg:block"
                  heading={activeSlide ? activeSlide.title : heading} // Default to initial heading if no active slide
                  description={activeSlide ? `${activeSlide.city}, ${activeSlide.state}, ${activeSlide.country}` : description}
                />
                <DestinationTextSlider arrows={false}>
                  {activeSlide && (
                    <DestinationText>
                      <QuoteContainer>
                        <Quote>
                          <QuotesLeft className="w-2 h-2 inline-block mr-1" /> {/* Smaller size for left icon */}
                          {activeSlide.description.substring(0, 250)}
                          <QuotesRight className="w-2 h-2 inline-block ml-1" /> {/* Smaller size for right icon */}
                        </Quote>
                      </QuoteContainer>
                    </DestinationText>
                  )}
                </DestinationTextSlider>
              </TextContainer>
            </Destination>
          </Destinations>
        </DestinationsContainer>
      </Content>
      <DecoratorBlob1 />
      <DecoratorBlob2 />
    </Container>
  );
};

const HeadingInfoMain = ({ subheading, heading, description, ...props }) => (
  <div {...props}>
    {subheading ? <Subheading>{subheading}</Subheading> : null}
  </div>
);

const HeadingInfo = ({ subheading, heading, description, ...props }) => (
  <div {...props}>
    <HeadingTitle>{heading}</HeadingTitle>
    <Description>{description}</Description>
  </div>
);
